<p>
  @for (line of lines(); track $index) {
    {{ line }}<br />
  }
</p>
<lib-chip [text]="chipText()" [type]="chipType()" />
